import { ICarrierSchema } from './carrier-schema.interface';
import { IDeviceSchema } from './vehicle-schema.interface';
import { IVehicleSchema } from './vehicle-schema.interface';
import { ISemitrailerCapacity, ISemitrailerCompartment, ISemitrailerDimensions } from '../semi-output-dto.interface';

export interface ISemitrailerSchema {
    id: string;
    organizationId?: string;
    licensePlate: string;
    externalId?: string | null;
    name?: string;
    vin?: string;
    make?: string;
    model?: string;
    year?: number;
    bodyType?: string;
    cargoType?: string;
    axles?: string;
    dimensions?: ISemitrailerDimensions | null;
    capacity?: ISemitrailerCapacity | null;
    compartments?: ISemitrailerCompartment[] | null;
    brakeType?: string[] | null;
    suspensionType?: string;
    tireType?: string;
    kingPin?: string;
    device?: IDeviceSchema | null;
    carrier?: ICarrierSchema;
    vehicleId?: string;
    vehicle?: IVehicleSchema;
    createdAt?: string;
    updatedAt?: string;
    isDeleted?: boolean;
    deletedAt?: string;
    hasDevice?: boolean;
}
